import React from 'react';
import IconProps from '../../icons';

const CheckCircleFilled = ({ width = 24, color = 'var(--brand-600)' }: IconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    viewBox='0 0 24 24'
    fill='none'
  >
    <path
      d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z'
      fill={color}
    />
    <path
      d='M7.5 12L10.5 15L16.5 9'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default CheckCircleFilled;
